/* ARÔME Dani Prueba · Quick buy desde tarjetas, sin navegar a cada ficha */
(() => {
  const dialog = document.querySelector('#arome-quick-buy-dialog');
  if (!dialog) return;
  const title = dialog.querySelector('[data-arqb-title]');
  const image = dialog.querySelector('[data-arqb-image]');
  const options = dialog.querySelector('[data-arqb-options]');
  const submit = dialog.querySelector('[data-arqb-submit]');
  const error = dialog.querySelector('[data-arqb-error]');
  const note = dialog.querySelector('[data-arqb-note]');
  const details = dialog.querySelector('[data-arqb-details]');
  const toast = document.querySelector('#arome-quick-buy-toast');
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  let active = null;
  let chosen = null;
  let busy = false;
  let toastTimer;

  function showError(message) {
    error.textContent = message || 'No se pudo agregar el perfume. Intenta nuevamente.';
    error.hidden = false;
  }
  function resetError() {
    error.textContent = '';
    error.hidden = true;
  }
  function showToast(message) {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.textContent = message;
    toast.hidden = false;
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
  }
  function allChoices(card) {
    return Array.from(card.querySelector('.ar-qb-card-options')?.content.querySelectorAll('[data-ar-qb-option]') || []);
  }
  function minQty(choice) { return Math.max(1, Number(choice?.dataset.variantMin || 1)); }
  function stepQty(choice) { return Math.max(1, Number(choice?.dataset.variantStep || 1)); }
  function choose(choice) {
    if (!choice || choice.disabled) return;
    chosen = choice;
    options.querySelectorAll('[data-ar-qb-option]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.variantId === choice.dataset.variantId));
    });
    submit.disabled = false;
    submit.textContent = 'Agregar al carrito · ' + (choice.dataset.variantPrice || '');
    const min = minQty(choice);
    note.hidden = min <= 1;
    note.textContent = min > 1 ? 'Esta presentación requiere un mínimo de ' + min + ' unidades.' : '';
    resetError();
  }
  function openPicker(trigger, choices) {
    const card = trigger.closest('.ar-qb-card');
    if (!card) return;
    active = trigger;
    chosen = null;
    title.textContent = trigger.dataset.productTitle || 'Perfume ARÔME';
    details.href = trigger.dataset.productUrl || trigger.getAttribute('href') || '/collections/all';
    const src = trigger.dataset.productImage || '';
    image.hidden = !src;
    if (src) image.src = src;
    image.alt = title.textContent;
    options.replaceChildren(card.querySelector('.ar-qb-card-options').content.cloneNode(true));
    submit.disabled = true;
    submit.textContent = 'Agregar al carrito';
    note.hidden = true;
    resetError();
    dialog.showModal();
    const first = options.querySelector('[data-ar-qb-option]:not(:disabled)');
    if (first) choose(first);
    dialog.querySelector('[data-arqb-close]')?.focus();
  }
  function toggleBusy(state, trigger) {
    busy = state;
    if (trigger) {
      trigger.setAttribute('aria-busy', String(state));
      trigger.classList.toggle('loading', state);
    }
    submit.disabled = state || !chosen;
    if (state) submit.textContent = 'Agregando…';
    else if (chosen) submit.textContent = 'Agregar al carrito · ' + (chosen.dataset.variantPrice || '');
  }

  async function refreshProgress(variantId) {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('arome:cart-state', { detail: { cart, threshold: 0 } }));
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'arome-quick-buy',
          productVariantId: variantId,
          cartData: cart
        })).catch(() => {});
      }
      const iconCount = document.querySelector('.ar-dani-exact__cart span');
      if (iconCount) iconCount.textContent = String(cart.item_count);
      const specialIcon = document.querySelector('.ar-dani-exact__cart');
      if (specialIcon) specialIcon.setAttribute('aria-label', 'Mi carrito: ' + cart.item_count + ' productos');
    } catch (_) { /* La compra ya se realizó, el progreso se actualizará al abrir el carrito. */ }
  }

  async function add(variantId, quantity, trigger) {
    if (!variantId || busy) return;
    toggleBusy(true, trigger);
    resetError();
    const cartUi = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const form = new FormData();
    form.append('id', String(variantId));
    form.append('quantity', String(quantity || 1));
    if (cartUi && typeof cartUi.getSectionsToRender === 'function') {
      form.append('sections', cartUi.getSectionsToRender().map(section => section.id).join(','));
      form.append('sections_url', window.location.pathname);
      if (typeof cartUi.setActiveElement === 'function') cartUi.setActiveElement(trigger || document.activeElement);
    }
    try {
      const address = window.routes?.cart_add_url || ((window.Shopify?.routes?.root || '/') + 'cart/add');
      const config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.method = 'POST';
      config.credentials = 'same-origin';
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = form;
      const response = await fetch(address, config);
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'No se pudo agregar esta presentación.');
      }
      if (dialog.open) dialog.close();
      document.dispatchEvent(new CustomEvent('arome:cart-updated'));
      // Portada: confirmar el artículo y mostrar el incentivo sin abrir el carrito.
      if (trigger?.closest('#arome-selection')) {
        const productName = trigger.dataset.productTitle || 'Perfume';
        let count = 0;
        try {
          const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
          if (cartResponse.ok) {
            const currentCart = await cartResponse.json();
            count = Number(currentCart.item_count) || 0;
          }
        } catch (_) { /* El artículo ya se añadió; mantener la confirmación. */ }
        const offer = count === 1 ? 'Agrega otro perfume: 2 por $749.'
          : count === 2 ? 'Agrega un tercero: 3 por $949.'
          : count >= 3 ? '¡Felicidades! Alcanzaste el precio especial de $316.33 por perfume. ¡Sigue eligiendo tus favoritos!'
          : '¡Sigue eligiendo tus fragancias!';
        if (cartUi && result.sections && typeof cartUi.renderContents === 'function') {
          try {
            cartUi.renderContents(result, { open: false });
          } catch (_) {
            // El artículo ya está en Shopify; el drawer se recuperará al siguiente render.
          }
        }
        showToast('✓ ' + productName + ' agregado. ' + offer);
        return;
      }
      await refreshProgress(variantId);
      // La portada usa exactamente el mismo componente y flujo que el catálogo.
      // Evitar abrir el componente sin sus secciones: no se vería el artículo agregado.
      if (cartUi && result.sections && typeof cartUi.renderContents === 'function') {
        try {
          cartUi.renderContents(result);
        } catch (renderError) {
          showToast('¡Agregado al carrito! Puedes revisar tu carrito.');
        }
      } else {
        showToast('¡Agregado al carrito! Puedes seguir eligiendo perfumes.');
      }
    } catch (err) {
      const msg = err?.message || 'No se pudo agregar el perfume.';
      if (!dialog.open && trigger) openPicker(trigger, []);
      showError(msg);
    } finally {
      toggleBusy(false, trigger);
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('#arome-selection .ar-best-card [data-ar-qb-trigger]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (busy || trigger.dataset.requiresPlan === 'true') return;
    const card = trigger.closest('.ar-qb-card');
    if (!card) return;
    const available = allChoices(card).filter(node => !node.disabled);
    if (!available.length) {
      showToast('Esta fragancia no está disponible por el momento.');
      return;
    }
    const only = available.length === 1 ? available[0] : null;
    if (only && minQty(only) === 1 && stepQty(only) === 1) {
      active = trigger;
      chosen = only;
      add(only.dataset.variantId, 1, trigger);
    } else {
      openPicker(trigger, available);
    }
  }, true);

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.('[data-ar-qb-trigger]');
    if (trigger) {
      if (!trigger.closest('.ar-qb-card')) return;
      if (trigger.dataset.requiresPlan === 'true') return; // Respeta productos de suscripción.
      event.preventDefault();
      if (busy) return;
      const available = allChoices(trigger.closest('.ar-qb-card')).filter(node => !node.disabled);
      if (!available.length) {
        showToast('Esta fragancia no está disponible por el momento.');
        return;
      }
      const only = available.length === 1 ? available[0] : null;
      if (only && minQty(only) === 1 && stepQty(only) === 1) {
        active = trigger;
        chosen = only;
        add(only.dataset.variantId, 1, trigger);
      } else {
        openPicker(trigger, available);
      }
      return;
    }
    const option = event.target.closest?.('#arome-quick-buy-dialog [data-ar-qb-option]');
    if (option) choose(option);
    const close = event.target.closest?.('[data-arqb-close]');
    if (close) dialog.close();
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });
  submit.addEventListener('click', () => {
    if (chosen && active && !busy) add(chosen.dataset.variantId, minQty(chosen), active);
  });
})();